import api from './api';

export interface XeroContact {
  id: string;
  status: string;
  name: string;
  email: string;
  bankAccountDetails: string;
  taxNumber: string;
  accountsReceivableTaxType: string;
  accountsPayableTaxType: string;
  addresses: Array<{
    type: string;
    city: string;
    region: string;
    postalCode: string;
    country: string;
  }>;
  phones: Array<{
    type: string;
    number: string;
  }>;
  updatedDate: string;
  isSupplier: boolean;
  isCustomer: boolean;
}

export interface XeroContactsResponse {
  success: boolean;
  message: string;
  data: {
    contacts: XeroContact[];
    pagination: {
      pageSize: number;
      total: number;
      nextPageInfo?: string;
      hasNextPage: boolean;
    };
  };
  meta: {
    requestId: string;
    timestamp: string;
    path: string;
    method: string;
    ip: string;
    userAgent: string;
  };
}

export interface XeroContactsParams {
  tenantId: string;
  pageSize?: number;
  status?: 'ACTIVE' | 'ARCHIVED' | 'GDPRREQUEST';
  pageInfo?: string;
}

export const xeroApiService = {
  /**
   * Get contacts from Xero via API Gateway (proxied through backend)
   */
  async getContacts(params: XeroContactsParams): Promise<XeroContactsResponse> {
    const { tenantId, pageSize = 10, status, pageInfo } = params;
    
    const queryParams = new URLSearchParams();
    queryParams.append('tenantId', tenantId);
    if (pageSize) queryParams.append('pageSize', pageSize.toString());
    if (status) queryParams.append('status', status);
    if (pageInfo) queryParams.append('pageInfo', pageInfo);
    
    const url = `/xero/contacts?${queryParams.toString()}`;
    
    const response = await api.get<XeroContactsResponse>(url);
    return response.data;
  },
};

export default xeroApiService;
